<p-carousel [value]="items" [numVisible]="visibleItems"  [numScroll]="visibleItems" [circular]="false"
            [showNavigators]="showNavigation" [showIndicators]="showNavigation" [responsiveOptions]="responsiveOptions">
    <ng-template let-item pTemplate="item">
        <app-carousel-item [item]="item" [order]="order"></app-carousel-item>
    </ng-template>
</p-carousel>

